import React from "react";

const BlogDetailsMain = (props) => {
  const { postDescription} = props;
const cleanContent = (html) => {
    if (!html) return "";

    return html
      .split(/<br\s*\/?>|<\/?p>/) 
      .filter(item => item.trim() !== "" && item !== "&nbsp;")
      .map(text => `<p>${text}</p>`)
      .join("");
  };

  return (
    <div className="back__course__page_grid react-courses__single-page pb---40 pt---110">
      <div className="container pb---70">
        <div className="row">
          <div className="col-lg-8">
            <div className="blog-single-inner">
              <div className="blog-content">
              <div
        dangerouslySetInnerHTML={{ __html: cleanContent(postDescription) }}
      />
                {/* <div className="blog-image">
                  <img
                    src={require(`../../assets/images/blog/${postImg}`)}
                    alt={postTitle}
                  />
                </div> */}

               


               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsMain;
